import menuInit from './menu.js'
import map from './maps.js'

menuInit()
map()
